import Vue from 'vue';
import VueRouter from 'vue-router';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import Form from './services/form';
import { get, eachRight, replace } from 'lodash';
import moment from 'moment';
import axios from 'axios';
import VTooltip from 'v-tooltip';
import VuejsDialog from 'vuejs-dialog';
import Loading from 'vue-loading-overlay';
import vSelect from 'vue-select';
import Vuelidate from 'vuelidate';
import showTip from './components/show-tip';
import paginationRecord from './components/pagination-record';
import showError from './components/show-error';
import moduleInfo from './components/module-info';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import toastr from 'toastr';
import VueChatScroll from 'vue-chat-scroll';
import VueTimeago from 'vue-timeago';
import ru from 'date-fns/locale/ru';
import jquery from 'jquery';
import beautifulChat from './plugins/vue-beautiful-chat/components/index';
import VueVirtualScroller from 'vue-virtual-scroller';
import GSignInButton from 'vue-google-signin-button';
import FBSignInButton from 'vue-facebook-signin-button';

import App from './App.vue';
import router from './router';
import store from './store';
import helper from './services/helper';
import FormBuilderPlugin from './plugins/v-form-builder/main';

import './styles/style.scss';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './styles/my-style.scss';
import './styles/toastr.scss';
import './styles/custom-v-select.scss';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import Sandbox from './sandbox.vue';
import './registerServiceWorker';
import vuePositionSticky from 'vue-position-sticky';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VCalendar from 'v-calendar';


Vue.prototype.jsTrans = key =>
  get(
    {
      layout: {
        telegramBot: 'Расписание'
      }
    },
    key
  );

/**
 * @todo сделать правильно
 */
let i18n = null;

Vue.prototype.trans = (string, args) => {
  let value = get(window.i18n, string);

  eachRight(args, (paramVal, paramKey) => {
    value = replace(value, `:${paramKey}`, paramVal);
  });
  return value;
};

library.add(fas);

window.moment = moment;
window.Form = Form;
window.Vue = Vue;
window.axios = axios;
window.helper = helper;
window.i18n = i18n;
window.toastr = toastr;
window.$ = window.jQuery = jquery;

Vue.use(VueRouter);
Vue.use(beautifulChat);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VTooltip);
Vue.use(VuejsDialog);
Vue.use(Loading);
Vue.use(Vuelidate);
Vue.use(VueChatScroll);
Vue.use(VueTimeago, {
  name: 'timeago',
  locale: 'ru',
  locales: { ru }
});
Vue.use(VueVirtualScroller);
Vue.use(vuePositionSticky);
Vue.use(VueAwesomeSwiper, /* { default options with global component } */);
Vue.use(VCalendar, {
  componentPrefix: 'vc'
});
Vue.use(GSignInButton);
Vue.use(FBSignInButton);

Vue.component('show-tip', showTip);
Vue.component('pagination-record', paginationRecord);
Vue.component('show-error', showError);
Vue.component('module-info', moduleInfo);
Vue.component('fai', FontAwesomeIcon);
Vue.component('v-select', vSelect);
Vue.component('form-builder', () =>
  import('./plugins/v-form-builder/FormBuilder')
);

if (process.env.VUE_APP_API_URL) {
  window.axios.defaults.baseURL = process.env.VUE_APP_API_URL;
}
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Authorization'] =
  'Bearer ' + localStorage.getItem('auth_token');

Vue.config.productionTip = false;

Vue.use(FormBuilderPlugin);

if (!true) {
  new Vue({
    render: h => h(Sandbox)
  }).$mount('#app');
} else {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
}
